import * as helper from './../../../../../VX/View/Assets/Js/helper';

// Put your Javascript here - You can use ES2015 Javascript, because we use Webpack with Babel
require('./../Sass/base.scss');

// Require babel polyfill before anything else so stupid IE can handle modern stuff like Symbols etc.
if (!(global as any)._babelPolyfill) {
	require('babel-polyfill');
}

helper.onDocumentLoaded(() => {
	const wrapper = helper.$('#wrapper');
	const url = helper.getData(wrapper, 'url');
	const steps = helper.$('div.survey');
	let pointer = 0;
	const buttons = helper.$('.next');
	const balken: HTMLDivElement = document.querySelector('#loader .indicator');
	balken.style.width = '1%';

	const lastPage = async () => {
		await nextStep();
		await helper.wait(1);
		window.location.href = url;
	}

	async function nextStep() {
		await helper.fadeOut(steps[pointer]);
		helper.hide(steps[pointer]);
		pointer++;
		helper.removeClass(steps[pointer], 'd-none');
		await helper.fadeIn(steps[pointer]);
	}

	for (const button of buttons) {
		helper.addClickListener(button, async (e: MouseEvent) => {
			e.preventDefault();
			await nextStep();

			if (pointer === 4) {
				await helper.wait(3);
				await nextStep();

				let balkenWidth = 1;
				const interval = setInterval(async () => {
					balkenWidth++;
					if (balkenWidth > 100) {
						balkenWidth = 100;
						clearInterval(interval);
						await helper.wait(0.75);
						lastPage();
					}
					balken.style.width = balkenWidth + '%';
					balken.innerText = balkenWidth + '%';
				}, 30)
			}
		})
	}
})
